import React from 'react'

export const genericCallToActionContent = {
  heading:
    'Lets work together on your strategy to design, produce, and sell your course online.',
  description: (
    <>
      <p>
        You're an expert with an idea for a course you'd like to sell, but don't
        know where to start.
      </p>
      <p>
        You've got a full internet of options for designing and selling your
        course.
      </p>
      <p>
        Narrow down your options and get on the right path to successfully
        selling your course.
      </p>
      <p>
        Get direct expert feedback on your course idea by entering your email
        below.
      </p>
    </>
  ),
  button: (
    <div className="flex flex-row justify-center align-middle items-center mx-auto">
      <span
        className="font-symbol lowercase sm:text-5xl text-3xl"
        aria-hidden="true"
      >
        o
      </span>
      <span className="px-2">Let's Get Started</span>{' '}
      <span
        className="font-symbol lowercase sm:text-5xl text-3xl"
        aria-hidden="true"
      >
        r
      </span>
    </div>
  ),
  info: `There's no obligation. This isn't a sales pitch. We respect your privacy. Unsubscribe at any time.`,
}

export const strategySessionContent = {
  heading: 'Schedule a Strategy Session for your Course',
  description: (
    <>
      <p>
        You're an expert with an idea for a course you'd like to sell, but don't
        know where to start.
      </p>
      <p>
        You've got a full internet of options for designing and selling your
        course.
      </p>
      <p>
        We will help narrow down the options and get you set on the right path
        to successfully selling your course.
      </p>
      <p>
        Get direct expert feedback on your course idea by{' '}
        <strong>entering your email below.</strong>
      </p>
    </>
  ),
  button: (
    <>
      <span
        className="font-symbol lowercase sm:text-5xl text-3xl"
        aria-hidden="true"
      >
        o
      </span>
      <span className="px-1">Let's Get Started</span>{' '}
      <span
        className="font-symbol lowercase sm:text-5xl text-3xl"
        aria-hidden="true"
      >
        r
      </span>
    </>
  ),
  info: `There's no obligation. This isn't a sales pitch. We respect your privacy. Unsubscribe at any time.`,
}

export const secretSauceContent = {
  caption: 'With Badass',
  heading: (
    <>
      We will squeeze every last drop of the secret sauce that goes into
      producing{' '}
      <strong className="text-badass-green-500">courses that sell.</strong>
    </>
  ),
}

export const headerContent = {
  caption: 'Sell Your Course Online',
  heading: <>Make Life-Changing Money Teaching What You Know</>,
  byline:
    'Take ownership of your educational content and sell an online course that helps learners achieve their goals.',
  callout: (
    <>
      <span className="font-symbol" aria-hidden="true">
        s
      </span>
      Your expertise is valuable{' '}
      <span className="font-symbol" aria-hidden="true">
        t
      </span>
    </>
  ),
}

export const projects = {
  caption: `Some of the projects that we've shipped:`,
  byline: (
    <>
      <span className="font-symbol" aria-hidden="true">
        o{' '}
      </span>
      This is your playbook
      <span className="font-symbol" aria-hidden="true">
        {' '}
        r
      </span>
    </>
  ),
  items: [
    {
      title: 'EpicReact.dev',
      byline: 'with Kent C. Dodds',
      caseStudyUrl: 'https://www.skillrecordings.com/epic-react',
      instructor: {
        avatar: '/assets/projects/kent-c-dodds.png',
        name: 'Kent C. Dodds',
      },
      image: (
        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 40 45"
          className="text-badass-cyan-400 w-9"
        >
          <path
            fill="currentColor"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.066 24.566c.62 0 1.162.465 1.201 1.124.232 4.882.891 9.338 1.899 12.554 1.085 3.449 2.208 4.379 2.673 4.379.698 0 2.093-1.666 3.217-6.238a1.155 1.155 0 0 1 1.395-.853c.62.155 1.007.775.852 1.395-1.279 5.231-3.178 8.021-5.464 8.021-2.015 0-3.642-2.015-4.92-6.045-1.047-3.37-1.783-8.06-1.977-13.135 0-.62.465-1.163 1.124-1.202ZM19.839 0c2.287 0 4.185 2.79 5.464 8.021.155.62-.233 1.24-.852 1.395a1.155 1.155 0 0 1-1.395-.853c-1.124-4.572-2.52-6.238-3.217-6.238-1.2 0-3.72 4.456-4.456 14.686.31-.194.66-.388.97-.582 9.686-5.58 20.652-9.145 22.938-5.192.853 1.433.349 3.37-1.433 5.734-1.278 1.667-3.216 3.565-5.735 5.619 5.193 4.184 8.641 8.524 7.092 11.237-.66 1.124-1.977 1.705-3.992 1.705-1.046 0-2.247-.155-3.642-.465-3.487-.775-7.866-2.48-12.36-4.844 0-.038-.04-.038-.04-.038-.038 0-.038-.04-.077-.04-.078-.038-.155-.116-.194-.154l-.038-.039c-.04-.077-.117-.155-.155-.232-.04-.04-.04-.04-.04-.078 0-.077-.038-.116-.038-.155-.039-.039-.039-.077-.039-.116-.039-.039-.039-.078-.039-.116v-.233c.04-.039.04-.077.04-.116.038-.039.038-.078.038-.116 0-.078 0-.117.039-.155.038-.04.038-.04.038-.078.04-.039.078-.116.117-.155.039 0 .039-.039.039-.039l.116-.116s0-.039.038-.039c.04 0 .04-.038.078-.038.039-.04.078-.04.116-.078a67.986 67.986 0 0 0 2.868-1.589 67.404 67.404 0 0 0 3.952-2.44 1.141 1.141 0 0 1 1.627.31 1.141 1.141 0 0 1-.31 1.627 81.093 81.093 0 0 1-4.068 2.518c-.31.194-.659.35-.969.543 8.834 4.262 14.298 4.61 14.957 3.487.581-.969-1.627-4.533-7.401-9.028a1.206 1.206 0 0 1-.349-.271c-1.472-1.085-3.1-2.248-4.998-3.41-.582-.31-.737-1.046-.388-1.589.31-.581 1.046-.736 1.589-.387A80.085 80.085 0 0 1 30.34 21c6.162-4.844 7.363-7.866 6.937-8.602-.776-1.356-8.486-.465-19.762 6.045S1.628 31.192 2.403 32.549c.31.58 2.48.968 7.013-.31.62-.194 1.24.155 1.434.775.194.62-.155 1.24-.775 1.433-2.247.659-4.146.969-5.657.969-2.015 0-3.371-.581-4.03-1.705-1.55-2.635 1.783-6.975 7.053-11.237-3.45-2.79-8.951-7.943-7.053-11.198 1.162-2.015 4.495-2.248 9.687-.736.62.155.969.813.775 1.433-.155.62-.813.969-1.434.775-4.533-1.317-6.664-.93-7.013-.348-.427.736.775 3.758 6.974 8.64a65.52 65.52 0 0 1 3.604-2.518C13.407 9.958 15.46 0 19.839 0Z"
          />
        </svg>
      ),
    },
    {
      title: 'TestingAccessibility.com',
      byline: 'with Marcy Sutton',
      instructor: {
        avatar: '/assets/projects/marcy-sutton.jpg',
        name: 'Marcy Sutton',
      },
      image: (
        <svg
          aria-hidden="true"
          className="w-9 -rotate-6"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 43 43"
        >
          <circle
            cx="21.5"
            cy="21.5"
            r="20.5"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M23.915 11.091a2.994 2.994 0 0 0 .486-1.639 2.98 2.98 0 0 0-.216-1.139 2.93 2.93 0 0 0-.633-.964 2.867 2.867 0 0 0-.951-.638 2.824 2.824 0 0 0-1.12-.21 2.86 2.86 0 0 0-1.604.508 2.94 2.94 0 0 0-1.058 1.33 3.007 3.007 0 0 0-.156 1.705 2.97 2.97 0 0 0 .798 1.507c.407.41.923.69 1.485.802a2.848 2.848 0 0 0 1.672-.173 2.91 2.91 0 0 0 1.297-1.089Zm-7.768 21.75c-.134.606-.266 1.2-.399 1.778-.046.86.139 1.412.87 1.59.731.179 1.263-.116 1.54-.822a8.62 8.62 0 0 0 .304-1.025l.558-2.21c.435-1.723.868-3.442 1.324-5.159.03-.116.057-.242.084-.37.132-.633.278-1.33 1.048-1.34.823-.008.969.704 1.102 1.352.029.14.057.277.09.403.394 1.458.763 2.92 1.133 4.382.307 1.216.614 2.431.935 3.644.246.955.864 1.332 1.593 1.16.73-.17 1.066-.81.874-1.78a70.82 70.82 0 0 0-.812-3.514c-1.053-4.172-1.913-8.367-1.642-12.719.081-1.287.376-1.689 1.607-1.855.455-.062.91-.119 1.364-.176a82.974 82.974 0 0 0 2.054-.274 17.122 17.122 0 0 0 2.346-.46c.708-.214.988-.797.843-1.548-.144-.75-.648-1.1-1.39-1.049-.265.019-.53.065-.794.11-.145.026-.29.052-.437.072-4.182.59-8.364.965-12.598.573a112.004 112.004 0 0 1-6.087-.724c-1.095-.162-1.811.55-1.629 1.558.131.711.624 1.043 1.27 1.143 1.704.263 3.409.516 5.118.745 1.501.2 1.788.53 1.838 2.042a34.93 34.93 0 0 1-1.107 10.242c-.378 1.417-.695 2.852-1 4.232Z"
            clipRule="evenodd"
          />
        </svg>
      ),
    },

    {
      title: 'egghead.io',
      byline: `where we've published hundreds of bite-sized courses`,
      instructors: [
        {avatar: '/joel-hooks.jpg', name: 'Joel Hooks'},
        {
          avatar: '/assets/projects/john-lindquist.jpeg',
          name: 'John Lindquist',
        },
      ],
      image: (
        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          className="w-9"
          fill="none"
          viewBox="0 0 44 46"
        >
          <path
            fill="#fff"
            d="M21.983 45.481c-9.222.012-16.826-7.216-17.285-16.425v-.033a4.122 4.122 0 0 1-3.48-3.078C.733 24.052.08 21.225.001 18.509a3.866 3.866 0 0 1 2.293-3.656c1.41-.633 3.422-1.151 5.958-1.543 1.418-3.28 3.093-6.13 4.863-8.278C15.874 1.693 18.858 0 21.983 0c3.125 0 6.105 1.693 8.86 5.033 1.762 2.148 3.443 4.995 4.859 8.267 2.518.38 4.527.9 5.977 1.546a3.861 3.861 0 0 1 2.293 3.65c-.077 2.731-.73 5.559-1.213 7.447a4.122 4.122 0 0 1-3.487 3.082v.031A17.31 17.31 0 0 1 21.975 45.48l.006.001h.002Z"
          />
          <path
            fill="#FCFBFA"
            d="M21.972 2.877c8.007 0 14.5 17.211 14.5 25.22 0 8.008-6.492 14.5-14.502 14.5-8.007 0-14.499-6.49-14.499-14.5.002-8.009 6.494-25.22 14.5-25.22Z"
          />
          <path
            fill="#252526"
            d="m40.358 16.768-5.916 2.086s.916 2.784.924 2.804c.009.021 5.894-.759 5.894-.759l-.902-4.131Zm-36.772 0L9.5 18.854s-.914 2.784-.923 2.804c-.008.021-5.891-.759-5.891-.759l.9-4.131h-.001Z"
          />
          <path
            fill="#E0E0E0"
            d="M15.885 16.274a1.844 1.844 0 0 1 1.865 1.552 24.29 24.29 0 0 1 .37 3.05c.006.286-.02.572-.077.853a24.63 24.63 0 0 0-.292-2.05 1.844 1.844 0 0 0-1.864-1.553 50.628 50.628 0 0 0-6.644.506 45.57 45.57 0 0 1 .672-1.94 50.214 50.214 0 0 1 5.97-.418Zm20.56 11.179c-5.223-.27-9.683-1.94-10.69-2.537-.785-.375-1.786-1.172-2.074-3.162-.193 2.192.22 4.19 2.28 5.176.15.09 4.09 2.04 10.449 2.375.051-.616.063-1.235.035-1.852Zm-28.93 0c5.223-.27 9.683-1.94 10.69-2.537.785-.375 1.786-1.172 2.074-3.162.193 2.192-.22 4.19-2.28 5.176-.15.09-4.09 2.04-10.449 2.375a14.402 14.402 0 0 1-.035-1.852Zm20.529-11.18a1.844 1.844 0 0 0-1.864 1.553 24.27 24.27 0 0 0-.37 3.05c-.006.286.02.572.078.853.073-.738.175-1.44.29-2.05a1.847 1.847 0 0 1 1.865-1.553c2.223.023 4.443.192 6.643.506a45.044 45.044 0 0 0-.672-1.94 50.19 50.19 0 0 0-5.969-.418h-.001Z"
          />
          <path
            fill="#56555C"
            d="M9.289 14.705c1.424-3.453 3.131-6.44 4.938-8.641 2.461-2.985 5.066-4.497 7.74-4.497 2.678 0 5.282 1.512 7.742 4.494 1.813 2.198 3.527 5.186 4.938 8.643l.07.177-.177-.026c-.503-.067-.911-.115-1.41-.176h-.064l-.024-.057C31.44 10.883 28.706 6 25.174 3.96a6.393 6.393 0 0 0-3.206-.931 6.393 6.393 0 0 0-3.205.931c-3.524 2.037-6.25 6.898-7.866 10.657l-.024.056h-.061a33.02 33.02 0 0 0-1.412.177l-.176.025.065-.17ZM36.61 25.648c-.393-.011-.79-.027-1.18-.05h-.12l-.017-.122c-.353-2.749-1.142-5.969-2.24-9.062l-.07-.231.237.032c.449.06.882.127 1.305.198l.087.014.028.082c1.058 3.09 1.807 6.276 2.128 8.974l.02.177-.178-.014v.002Z"
          />
          <path
            fill="#252526"
            d="M35.318 18.683a52.336 52.336 0 0 0-.687-2.17l-.027-.084-.087-.014c-.416-.071-.856-.138-1.305-.198l-.23-.034.08.228c.243.685.47 1.375.683 2.069.752.087 1.178.147 1.573.203Z"
          />
          <path
            fill="#56555C"
            d="M7.282 25.421c.322-2.698 1.078-5.884 2.128-8.973l.028-.083.087-.016c.417-.07.857-.138 1.305-.197l.239-.032-.08.226c-1.096 3.093-1.89 6.31-2.24 9.06l-.016.124h-.12c-.392.023-.79.039-1.18.048h-.177l.026-.157Z"
          />
          <path
            fill="#252526"
            d="m9.525 16.349-.087.013-.026.085c-.245.72-.474 1.445-.687 2.174.736-.093.949-.083 1.565-.148.216-.706.45-1.424.705-2.128l.08-.225-.24.032c-.437.06-.874.125-1.31.197Z"
          />
          <path
            fill="#56555C"
            d="M21.972 43.9a15.811 15.811 0 0 1-14.71-10.014 16.006 16.006 0 0 1-1.088-6.434v-.1h.1c.515-.013.867-.026 1.233-.045h.115v.114a14.356 14.356 0 0 0 24.695 10.625 14.22 14.22 0 0 0 3.025-4.738 14.368 14.368 0 0 0 .958-5.884v-.116h.115c.513.027.866.038 1.234.046h.099v.099a16.01 16.01 0 0 1-1.061 6.43 15.795 15.795 0 0 1-14.711 10.02h-.004V43.9Z"
          />
          <path
            fill="#252526"
            d="M7.672 29.307a15.683 15.683 0 0 1-.04-1.894v-.115h-.114c-.37.02-.723.033-1.234.047h-.1v.097a16.67 16.67 0 0 0 .044 1.9h.047c.476 0 .942-.02 1.385-.042l.012.007ZM37.76 27.35h-.1c-.373 0-.726-.02-1.233-.045h-.115v.114c.027.626.013 1.252-.036 1.876l1.445.063c.05-.633.064-1.266.043-1.9l-.004-.108Z"
          />
          <path
            fill="#252526"
            d="M38.575 27.674a34.423 34.423 0 0 1-8.956-1.151 21.605 21.605 0 0 1-3.659-1.326l-.028-.022c-2.47-1.18-2.56-3.546-2.33-5.704.057-.544-.142-1.266-.716-1.648a1.63 1.63 0 0 0-1.81 0c-.575.38-.774 1.1-.717 1.643.23 2.159.134 4.525-2.329 5.705l-.028.014a21.554 21.554 0 0 1-3.66 1.342 34.422 34.422 0 0 1-8.956 1.15h-.013a2.762 2.762 0 0 1-2.646-2.09c-.469-1.81-1.094-4.523-1.166-7.069a2.51 2.51 0 0 1 1.486-2.371c3.399-1.508 10.28-2.076 13.215-2.037a3.795 3.795 0 0 1 2.728 1.127c.94-.44 1.96-.676 2.998-.692a7.327 7.327 0 0 1 2.998.69 3.78 3.78 0 0 1 2.706-1.125c1.764-.027 9.347.301 13.226 2.028a2.5 2.5 0 0 1 1.486 2.362c-.072 2.55-.705 5.277-1.16 7.083a2.762 2.762 0 0 1-2.645 2.09h-.024ZM28.061 16.387a1.746 1.746 0 0 0-1.762 1.465 24.367 24.367 0 0 0-.371 3.035c-.014 1.165.404 1.96 1.234 2.37 3.11 1.386 6.724 2.07 11.048 2.092a.733.733 0 0 0 .705-.546c.41-1.606.965-3.995 1.03-6.19a.515.515 0 0 0-.309-.49c-2.95-1.326-9.27-1.78-11.575-1.743v.007ZM4.306 18.12a.515.515 0 0 0-.307.488c.065 2.19.619 4.587 1.03 6.191a.731.731 0 0 0 .705.547c4.328-.02 7.936-.706 11.056-2.095.832-.406 1.248-1.205 1.235-2.373a24.17 24.17 0 0 0-.372-3.031 1.746 1.746 0 0 0-1.764-1.466c-1.342-.021-8.241.25-11.582 1.74l-.001-.001Z"
          />
        </svg>
      ),
    },
    {
      title: 'TestingJavaScript.com',
      byline: 'with Kent C. Dodds',
      instructor: {
        avatar: '/assets/projects/kent-c-dodds.png',
        name: 'Kent C. Dodds',
      },
      image: (
        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 43 37"
          className="text-badass-yellow-500 w-8"
        >
          <path
            fill="currentColor"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M42.633 5.934c.256.24.388.566.364.898-.231 3.676-4.717 7.07-9.138 9.033a13.828 13.828 0 0 0 1.86-3.264c2.408-1.49 4.404-3.346 4.942-5.14l-3.911-.338a28.06 28.06 0 0 0-.02-1.99l4.972.422c.353.013.688.149.931.379Zm-42.267 0c.244-.23.578-.366.932-.379l4.972-.422c-.03.694-.037 1.354-.02 1.99l-3.898.339c.538 1.793 2.534 3.648 4.942 5.14a13.832 13.832 0 0 0 1.86 3.253C4.733 13.878.234 10.5.002 6.823c-.02-.329.111-.65.364-.89Zm10.278 27.195h21.84c1.76 0 3.956 1.32 4.082 3.871H6.563c.115-2.551 2.312-3.871 4.08-3.871Zm19.028-1.25-16.335.012c5.21-2.34 4.803-6.288 4.803-6.566 0-3.361-3.235-5.788-5.71-7.945C6.895 12.552 6.701 5.613 6.772 3.73a1 1 0 0 1 .378-.739C9.494 1.002 15.487-.003 21.503 0c6.016.003 12.002 1.002 14.352 2.976a1 1 0 0 1 .378.743c.071 1.882-.123 8.821-5.656 13.649-2.473 2.172-5.71 4.605-5.71 7.944 0 .278-.408 4.226 4.805 6.567Z"
          />
        </svg>
      ),
    },
    {
      title: 'JustJavaScript.com',
      byline: 'from Dan Abramov and Maggie Appleton',
      caseStudyUrl: 'https://www.skillrecordings.com/just-javascript',
      instructors: [
        {avatar: '/assets/projects/dan-abramov.jpg', name: 'Dan Abramov'},
        {
          avatar: '/assets/projects/maggie-appleton.jpg',
          name: 'Maggie Appleton',
        },
      ],
      image: (
        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 38 36"
          className="text-white/80 w-8"
        >
          <path
            fill="currentColor"
            d="M7.577 35.357c-1.061 0-1.928-.324-2.6-.97-.648-.648-.971-1.553-.971-2.718v-8.307c0-1.138-.363-1.992-1.087-2.562-.699-.595-1.592-.892-2.679-.892v-3.999c1.087 0 1.98-.284 2.679-.854.724-.595 1.087-1.449 1.087-2.562V4.188c0-1.165.323-2.07.97-2.718C5.65.822 6.516.5 7.576.5h3.921V4.07h-2.95v8.734c0 .621-.103 1.216-.31 1.786a5.233 5.233 0 0 1-.854 1.475c-.363.44-.79.815-1.281 1.125a4.49 4.49 0 0 1-1.514.583v.31c.543.104 1.048.31 1.514.621.491.285.918.647 1.28 1.087.363.44.648.945.855 1.514.207.543.31 1.126.31 1.747v8.734h2.95v3.57h-3.92ZM30.451.499c1.035 0 1.89.324 2.562.97.673.647 1.01 1.553 1.01 2.718v8.306c0 1.113.349 1.967 1.047 2.562.699.57 1.592.854 2.679.854v3.999c-1.087 0-1.98.297-2.679.892-.698.57-1.048 1.424-1.048 2.562v8.307c0 1.165-.336 2.07-1.009 2.717-.673.647-1.527.97-2.562.97h-3.96v-3.57h2.99v-8.773c0-.621.103-1.203.31-1.747.207-.57.479-1.074.815-1.514.363-.44.777-.802 1.242-1.087a4.447 4.447 0 0 1 1.553-.62v-.272a4.916 4.916 0 0 1-1.553-.583 5.697 5.697 0 0 1-1.242-1.125 5.825 5.825 0 0 1-.815-1.475 5.182 5.182 0 0 1-.31-1.786V4.07h-2.99V.5h3.96Z"
          />
        </svg>
      ),
    },
    {
      title: 'TechnicalInterviews.dev',
      byline: 'by Emma Bostian',
      caseStudyUrl: 'https://www.skillrecordings.com/technical-interviews',
      instructor: {
        avatar: '/assets/projects/emma-bostian.jpg',
        name: 'Emma Bostian',
      },
      image: (
        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          className="w-11"
          fill="none"
          viewBox="0 0 53 41"
        >
          <g clipPath="url(#a)">
            <path
              fill="currentColor"
              className="text-white"
              fillRule="evenodd"
              d="m33.288 16.296 13.441 9.857Z"
              clipRule="evenodd"
            />

            <path
              fill="currentColor"
              className="text-red-400"
              fillRule="evenodd"
              d="M19.845 9.127a2.688 2.688 0 1 1 0-5.376 2.688 2.688 0 0 1 0 5.376Zm-3.49 1.664a5.578 5.578 0 1 0-1.71-2.33l-5.797 4.252 1.589 2.418 5.918-4.34ZM22 29.524l2-2.117 4.634 3.398a5.578 5.578 0 1 1-1.56 2.44L22 29.523Zm7.706 5.401a2.688 2.688 0 1 0 5.376 0 2.688 2.688 0 0 0-5.376 0ZM35.5 19.71l5.015 3.677a5.578 5.578 0 1 0 1.56-2.44l-4.755-3.486-1.82 2.249Zm7.647 5.357a2.688 2.688 0 1 0 5.376 0 2.688 2.688 0 0 0-5.376 0Z"
              clipRule="evenodd"
            />
            <path
              fill="currentColor"
              className="text-white"
              fillRule="evenodd"
              d="M46.727 9.126a2.688 2.688 0 1 1 0-5.376 2.688 2.688 0 0 1 0 5.376Zm-3.488 1.665a5.578 5.578 0 1 0-1.71-2.329l-4.751 3.483a5.578 5.578 0 0 0-8.69 6.373L23.336 21.8a5.554 5.554 0 0 0-3.49-1.226 5.555 5.555 0 0 0-3.502 1.235l-4.742-3.487a5.578 5.578 0 1 0-1.713 2.328l4.751 3.493a5.578 5.578 0 1 0 10.405-.013l4.751-3.484a5.578 5.578 0 0 0 8.69-6.373l4.752-3.483ZM6.404 18.984a2.688 2.688 0 1 1 0-5.376 2.688 2.688 0 0 1 0 5.376Zm13.441 9.857a2.688 2.688 0 1 1 0-5.376 2.688 2.688 0 0 1 0 5.376ZM30.6 16.296a2.688 2.688 0 1 0 5.377 0 2.688 2.688 0 0 0-5.377 0Z"
              clipRule="evenodd"
            />
          </g>
          <defs>
            <clipPath id="a">
              <path fill="#fff" d="M0 0h52.963v40.884H0z" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
  ],
}
